import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/hero/01-banner-private-water.avif")